const Error = () => <h2>Credenciales incorrectas. Inténtalo de nuevo.</h2>;
export default Error;